(ns machtfit.stepchall.create-team
  (:require [machtfit.core :as machtfit]
            [machtfit.startpage.api-events :as api-events]
            [machtfit.stepchall.api :as api]
            [machtfit.stepchall.help :as help]
            [machtfit.stepchall.icons :as icons]
            [machtfit.stepchall.modal :as modal]
            [machtfit.stepchall.share-team :as share-team]
            [machtfit.stepchall.subs :as subs]
            [machtfit.translation :refer [tr t tr-with-place-holders]]
            [re-frame.core :as rf]))

(defn- input [{:keys [type label subtitle value error-message on-change]}]
  [:div.sc_input-group
   [:label.sc_input-label label]
   [:input.sc_input {:type type
                     :value value
                     :on-change #(on-change (-> % .-target .-value))
                     :class [(when (some? error-message) "sc_input-error")]}]
   (when (some? error-message) [:div.sc_input-error-msg error-message])
   [:p.sc_input-subtitle subtitle]])

(rf/reg-event-db ::team-name-changed
  (fn [db [_ value]]
    (assoc-in db [:ui :stepchall :team-form :team-name] value)))

(defn- team-name-input []
  [input {:type "text"
          :label (tr "Teamname")
          :value @(rf/subscribe [:get [:ui :stepchall :team-form :team-name]])
          :error-message (case @(rf/subscribe [:get [:ui :page :error :name]])
                           :team-already-exists (tr "Dieser Teamname ist bereits vergeben.")
                           :invalid-team-name (tr "Teamname ungültig")
                           nil)
          :on-change #(rf/dispatch-sync [::team-name-changed %])}])

(rf/reg-event-db ::nickname-changed
  (fn [db [_ value]]
    (assoc-in db [:stepchall :participant :nickname] value)))

(defn nickname-input []
  [input {:type "text"
          :label (tr "Dein Name im Team")
          :subtitle (tr "Deinen Namen können nur andere Teammitglieder sehen.")
          :value @(rf/subscribe [:get [:stepchall :participant :nickname]])
          :error-message (case @(rf/subscribe [:get [:ui :page :error :name]])
                           :invalid-nickname (tr "Name ungültig")
                           nil)
          :on-change #(rf/dispatch-sync [::nickname-changed %])}])

(rf/reg-event-db ::has-access-code?-toggled
  (fn [db _]
    (update-in db [:ui :stepchall :team-form :has-access-code?] not)))

(defn- has-access-code?-switch []
  (let [checked? @(rf/subscribe [:get [:ui :stepchall :team-form :has-access-code?]])]
    [:div.sc_input-group
     [:div.sc_toggle-switch
      [:span.sc_toggle-switch-label {:class (when (not checked?) "active")} (tr "ohne Zugangscode")]
      [:input {:type "checkbox"
               :checked (if (some? checked?) checked? false)
               :on-change #(rf/dispatch [::has-access-code?-toggled])}]
      [:span.sc_toggle-switch-label {:class (when checked? "active")} (tr "mit Zugangscode")]]]))

(rf/reg-event-db ::access-code-changed
  (fn [db [_ value]]
    (assoc-in db [:ui :stepchall :team-form :access-code] value)))

(defn access-code-input []
  [input {:type "text"
          :label (tr "Zugangscode")
          :value @(rf/subscribe [:get [:ui :stepchall :team-form :access-code]])
          :subtitle (tr "Bestehend aus A-Z, Ä, Ö, Ü, 0-9")
          :error-message (case @(rf/subscribe [:get [:ui :page :error :name]])
                           :invalid-access-code (tr "Zugangscode ungültig")
                           :wrong-access-code (tr "Zugangscode falsch")
                           nil)
          :on-change #(rf/dispatch-sync [::access-code-changed %])}])

(defn team-privacy-box []
  (when @(rf/subscribe [:get [:stepchall :show-team-privacy-box?]])
    [:div.sc_input-group
     [:div.sc_interaction-box
      [:p (tr "Mit dem Eintreten in dieses Team stimmst du den Teilnahmebedingungen des Wettbewerbs zu. Diese kannst du in unserer Hilfe nachlesen.")]
      [:a.sc_button.sc_button-inline {:href (help/faq-url {:question :challenge-privacy})} (tr "Datenschutzhinweis")]]]))

(defn button [{:keys [on-click text disabled?]}]
  [:button.sc_button.sc_button-full-width
   {:on-click on-click
    :disabled disabled?
    :class (when disabled? "sc_button-disabled")}
   text])

(rf/reg-event-fx ::create-team-clicked
  (fn [{:keys [db]} [_ {:keys [team-color]}]]
    (let [nickname (-> db :stepchall :participant :nickname)
          {:keys [team-name
                  access-code
                  has-access-code?]} (-> db :ui :stepchall :team-form)]
      {:post (api/request db
                          {:function :stepchall-create-team
                           :params {:team_name team-name
                                    :access_code (when has-access-code? access-code)
                                    :nickname nickname
                                    :team_color team-color}})})))

(defn- create-team-button [{:keys [team-color]}]
  (let [team-name @(rf/subscribe [:get [:ui :stepchall :team-form :team-name]])]
    [button {:on-click #(rf/dispatch [::create-team-clicked {:team-color team-color}])
             :text (tr-with-place-holders
                    "Team {team-name} gründen"
                    {"team-name" (or team-name "")})}]))

(defn- create-team []
  (let [team-color (rand-nth @(rf/subscribe [:get [:stepchall :theme :team-palette]]))]
    [:div.sc
     [:div.sc_container
      [:div.sc_back {:on-click #(js/history.back)} [:i.sc_icon [icons/back]] (tr "zurück")]
      [:div {:style {:float "right"
                     :margin-right "1em"}} [help/help {:context :create-team}]]
      [:h2 (tr "Neues Team gründen")]
      [:p (tr "Gib deinem Team einen Namen damit andere Teilnehmer es finden können.")]
      [:div.sc_input-color-group
       [team-name-input]
       [:div.sc_input-color {:style {:background-color team-color}}]]
      [nickname-input]
      [:p (tr "Erlaube optional neue Teammitglieder nur mit Zugangscode.")]
      [has-access-code?-switch]
      (when @(rf/subscribe [:get [:ui :stepchall :team-form :has-access-code?]])
        [access-code-input])
      [team-privacy-box]
      [share-team/team-minimum-size-warning]
      [create-team-button {:team-color team-color}]]]))

(defn place-holders []
  {"team-name" (t @(rf/subscribe [:get [:stepchall :team :name]]))
   "access-code" @(rf/subscribe [:get [:stepchall :team :access-code]])})

(defn- team-created-successfully []
  (when @(rf/subscribe [::subs/is-team-member?])
    [modal/modal {:img-src (machtfit/static "img/stepchall/team-created.svg")
                  :title (tr "Team gegründet")
                  :content [(fn []
                              [:<> (tr-with-place-holders
                                    (if (some? @(rf/subscribe [:get [:stepchall :team :access-code]]))
                                      [:p "Herzlichen Glückwunsch! Du hast das Team " [:b [:q "{team-name}"]]
                                       " mit dem Zugangscode " [:b [:q "{access-code}"]]
                                       " gegründet. Kolleg:innen können ihm jetzt beitreten. Lade sie am besten gleich ein! Wir wünschen dir viel Spaß!"]

                                      [:p "Herzlichen Glückwunsch! Du hast das Team " [:b [:q "{team-name}"]]
                                       " gegründet. Kolleg:innen können ihm jetzt beitreten. Lade sie am besten gleich ein! Wir wünschen dir viel Spaß!"])
                                    (place-holders))
                               [share-team/copy-link]
                               [share-team/whatsapp-link]
                               [share-team/email-link]])]
                  :button-group [{:text (tr "Los geht's!")
                                  :page {:id :stepchall}}]
                  :close-button {:page {:id :stepchall}}}]))

(defn create-team-page []
  [:<>
   [create-team]
   [team-created-successfully]])

(rf/reg-event-fx ::navigate-to-stepchall-create-team
  (fn [{:keys [db]} _]
    (-> {:db db}
        (assoc-in [:db :ui :page] {:id :stepchall
                                   :subpage :create-team})
        (assoc :scroll-to {:frame :app-frame
                           :mode :page-top})
        (api-events/api-requests-on-stepchall-event))))
